import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MutationButton from './MutationButton';
import { extendedMutationType } from '../../types';

DeleteButton.propTypes = {
    extendedMutation: extendedMutationType.isRequired,
    confirmationMessage: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
};

function DeleteButton(props) {
    const {
        extendedMutation,
        confirmationMessage,
        disabled = false,
    } = props;
    const { t } = useTranslation();
    return (
        <MutationButton
            className="delete-button button-filled-red button"
            confirmationMessage={confirmationMessage}
            extendedMutation={extendedMutation}
            showConfirmationDialog
            disabled={disabled}
        >
            <FontAwesomeIcon icon="trash-alt" />&nbsp;{t('button.delete')}
        </MutationButton>
    );
}

export default DeleteButton;
